import { useEffect } from "react";
import { HeroHeader } from "../../components/HeroHeader";
import { Stack } from "../../components/Stack";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../HomePage/style.css";
import "./style.css";
import { Button } from "../../components/Button";
import { initFadeInAnimation } from "../../animation";
import { useSelector } from "react-redux";
import { selectAllContent } from "../../features/apartments/selectors";
import { useTranslation } from "react-i18next";
import { imagesResponse } from "../../api/responses";
import { Seo } from "../../components/Seo";
import { PageShell } from "../../components/PageShell";
import { useInitApp } from "../../hooks/useInitApp";
import { BOOKING_URL } from "../../constants/links";

gsap.registerPlugin(ScrollTrigger);

export const Sustainability = () => {
  useEffect(() => {
    initFadeInAnimation(".fade-in");
  }, []);
  const content = useSelector(selectAllContent);
  const { t } = useTranslation();
  useInitApp();

  return (
    <>
      <Seo
        title="Sostenibilità"
        description="Impegno e pratiche sostenibili di Isola Dei Mori a Sant'Antioco."
      />
      <PageShell>
      <HeroHeader
        title={t("sus-title")}
        imgSrc={content?.[4]?.url || imagesResponse[0].url}
        className="fade-in"
      />
      <Stack flexDirection="column">
        <div className="first-home">
          <div className="text-container-centered">
            <h1 className="fade-in">{t("sus-title")}</h1>
            <div className="description-first-home ">
              <span className="fade-in">{t("sus-1")}</span>
              <span className="fade-in">{t("sus-2")}</span>
              <span className="fade-in">{t("sus-3")}</span>
            </div>
          </div>
          <Stack className="button-group">
            <Button
              buttonTitle={t("discover-btn")}
              icon="ArrowForwardIosRounded"
              fontSize="md"
              className="button-home-book fade-in"
              onClick={() =>
                window.open(BOOKING_URL)
              }
            />
          </Stack>
        </div>
      </Stack>
      </PageShell>
    </>
  );
};
